<template>
  <Wrapper
    contentWidth="md"
    wrapperHeight="viewport"
    v-if="property"
  >
    <div class="py-12">

      <div class="flex flex-col gap-6">

        <div class="details">

          <div class="text-white mb-8">
            <h2 class="text-4xl text-center mb-3">
              {{ property.address.address }}
            </h2>
            <div class="text-center text-xl uppercase">
              {{ property.address.city }}, {{ property.address.state }}
            </div>
          </div>

          <div class="bg-neutral-800 text-white p-6 rounded-2xl">

            <Map :lat="property.latitude"
                 :lng="property.longitude"
                 class="bg-white rounded-xl overflow-hidden"
            />

            <div class="flex flex-wrap items-center justify-around mt-3">
              <template v-for="metric in metrics">
                <div class="w-1/2 md:w-auto flex flex-col items-center justify-start gap-3 p-3">
                  <div class="text-3xl lg:text-4xl">
                    <i class="fa-sharp fa-light fa-fw" :class="[`fa-${metric.icon}`]"></i>
                  </div>
                  <div class="text-center text-sm">
                    {{ metric['value'] }} {{ metric['label'] }}
                  </div>
                </div>
              </template>
            </div>

          </div>

        </div>

      </div>
    </div>
  </Wrapper>
</template>

<script>
import numeral from 'numeral';
import Wrapper from './Wrapper.vue';
import Map from './Map.vue';

export default {
  name: 'PropertyDetails',
  components: {Map, Wrapper},
  computed: {
    metrics() {
      return [
        {
          icon: 'calendar',
          label: 'Year Built',
          value: this.property.yearBuilt,
        },
        {
          icon: 'bed-empty',
          label: 'Bedrooms',
          value: this.property.bedrooms,
        },
        {
          icon: 'bath',
          label: 'Bathrooms',
          value: this.property.bathrooms,
        },
        {
          icon: 'ruler-triangle',
          label: 'Square Footage',
          value: this.numeral(this.property.squareFootage).format('0,0'),
        },
      ];
    },
  },
  data() {
    return {
      backgroundImage: null, //window.app.objectsUsedInCode.proposal_generator_desktop_image.url,
      property: window.app.property,
      estimate: window.app.estimate,
    };
  },
  methods: {
    numeral(value) {
      return numeral(value);
    }
  },
}
</script>

<style scoped lang="scss">

</style>
